export const setFirstPanelVisible = ({ state, effects }) => {
  state.menu.isVisibleFirstPanel = true
  effects.menu.fixedBody(true)
}

export const setFirstPanelHidden = ({ state, effects }) => {
  state.menu.isVisibleFirstPanel = false
  effects.menu.fixedBody(false)
  state.menu.isVisibleSecondPanel = false
  state.menu.activeFirstElement = null
  if (window.matchMedia('(max-width: 992px)').matches) {
    state.menu.animation.firstPanel = {
      show: 0,
      hidden: '-100',
      stagger: 75,
      staggerOpacity: 0,
      staggerSocial: 20
    }
  }
}

export const setSecondPanelVisible = ({ state, effects }, { id, item_id }) => {
  if (state.menu.isVisibleSecondPanel) {
    state.menu.activeFirstElement = parseFloat(id)
    return
  }

  state.menu.activeFirstElement = parseFloat(id)
  state.menu.isVisibleSecondPanel = true
  if (window.matchMedia('(max-width: 992px)').matches) {
    state.menu.animation.firstPanel = {
      show: '-35',
      hidden: '0',
      stagger: 0,
      staggerOpacity: 1,
      staggerSocial: 0
    }
  }
  return
}
export const setSecondPanelHidden = ({ state }) => {
  state.menu.activeFirstElement = null
  state.menu.isVisibleSecondPanel = false
  if (window.matchMedia('(max-width: 992px)').matches) {
    state.menu.animation.firstPanel = {
      show: 0,
      hidden: '-100',
      stagger: 75,
      staggerOpacity: 0,
      staggerSocial: 20
    }
  }
  return
}
